// client/src/components/plataforma/siteInstitucional/FixedElementsPanel.js
import React, { useCallback } from 'react';

// Seção de agendamento (hero "Quero Agendar!/Ver Loja") — fixa na posição da
// home (não entra na lista reordenável de SectionsManager), só o conteúdo é
// configurável. Exclusivo de conta (site/franquia e site/institucional não
// têm essa seção). A barra de navegação saiu daqui — agora é gerenciada de
// verdade em /site-institucional/navegacao (model NavItem), já que a antiga
// navConfig (5 booleans fixos) não dava pra estender e nem fazia sentido pra
// franquia/matriz (navbars completamente diferentes da de conta).
const FixedElementsPanel = React.memo(({ heroConfig, onHeroConfigChange, disabled = false }) => {
    const hero = heroConfig || {};
    const heroAtiva = hero.enabled !== false;

    const toggleHero = useCallback((key) => {
        onHeroConfigChange({ ...hero, [key]: hero[key] === false ? true : false });
    }, [hero, onHeroConfigChange]);

    // useAccountBanner é default-false (ausente = desligado) — diferente dos
    // outros flags acima (default-true, ausente = ligado) — por isso não usa
    // o mesmo toggleHero (que assume "ausente = true").
    const toggleUseAccountBanner = useCallback(() => {
        onHeroConfigChange({ ...hero, useAccountBanner: !hero.useAccountBanner });
    }, [hero, onHeroConfigChange]);

    const handleTextoChange = useCallback((key, value) => {
        onHeroConfigChange({ ...hero, [key]: value });
    }, [hero, onHeroConfigChange]);

    return (
        <fieldset className="form-section" disabled={disabled} style={disabled ? { opacity: 0.6 } : undefined}>
            <h3 className="form-section-title">📌 Elementos Fixos da Home</h3>
            <p className="text-sm text-gray-500 mb-4">
                Esses elementos ficam sempre na mesma posição da página (não entram na lista de seções abaixo) — aqui você só escolhe o que aparece dentro deles.
            </p>

            <div className="form-grid-container grid-cols-1 md:grid-cols-2">
                <div className="form-group">
                    <label className="font-semibold">Seção de Agendamento (topo da home)</label>
                    <div className="flex flex-col gap-2 mt-2">
                        <label className="flex items-center gap-2 text-sm cursor-pointer">
                            <input
                                type="checkbox"
                                checked={heroAtiva}
                                onChange={() => toggleHero('enabled')}
                            />
                            Seção ativa
                        </label>
                        <label className="flex items-center gap-2 text-sm cursor-pointer" style={{ opacity: heroAtiva ? 1 : 0.5 }}>
                            <input
                                type="checkbox"
                                checked={hero.showQueroAgendar !== false}
                                disabled={!heroAtiva}
                                onChange={() => toggleHero('showQueroAgendar')}
                            />
                            Botão &quot;Quero Agendar!&quot;
                        </label>
                        {hero.showQueroAgendar !== false && (
                            <input
                                type="text"
                                className="form-input"
                                style={{ marginLeft: '1.5rem', opacity: heroAtiva ? 1 : 0.5 }}
                                placeholder="Quero Agendar!"
                                value={hero.textoQueroAgendar || ''}
                                disabled={!heroAtiva}
                                onChange={(e) => handleTextoChange('textoQueroAgendar', e.target.value)}
                            />
                        )}
                        <label className="flex items-center gap-2 text-sm cursor-pointer" style={{ opacity: heroAtiva ? 1 : 0.5 }}>
                            <input
                                type="checkbox"
                                checked={hero.showVerLoja !== false}
                                disabled={!heroAtiva}
                                onChange={() => toggleHero('showVerLoja')}
                            />
                            Botão &quot;Ver Loja&quot;
                        </label>
                        {hero.showVerLoja !== false && (
                            <input
                                type="text"
                                className="form-input"
                                style={{ marginLeft: '1.5rem', opacity: heroAtiva ? 1 : 0.5 }}
                                placeholder="Ver Loja"
                                value={hero.textoVerLoja || ''}
                                disabled={!heroAtiva}
                                onChange={(e) => handleTextoChange('textoVerLoja', e.target.value)}
                            />
                        )}
                        <label className="flex items-center gap-2 text-sm cursor-pointer" style={{ opacity: heroAtiva ? 1 : 0.5 }}>
                            <input
                                type="checkbox"
                                checked={!!hero.useAccountBanner}
                                disabled={!heroAtiva}
                                onChange={toggleUseAccountBanner}
                            />
                            Usar Banner de Capa da conta como fundo
                        </label>
                    </div>
                </div>
            </div>
        </fieldset>
    );
});

export default FixedElementsPanel;
